module.exports = __webpack_public_path__ + "img/nvdm.6e682eba.jpg";